import { parseCurrency, removeCasasDecimais } from '@helper/parseCurrency'

import {
  getStatus,
  toCoverLocaleString,
  toLocaleString,
  toLocaleString2,
  toLocaleString3
} from '../strings'

export const parsePurchaseMrpData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'centro-id': item.estoque?.loja ? item.estoque?.loja?.id : 0,
      'centro-nome': item.estoque?.loja ? item.estoque?.loja?.descricao : 0,

      'produto-id': item.estoque?.produtoFornecedor
        ? item.estoque?.produtoFornecedor?.produto?.id
        : 0,
      'produto-categoria-compacta':
        item.estoque.categoriaCompactaDescricao.toUpperCase(),
      'produto-mundo': item.estoque.mundoDescricao.toUpperCase(),
      'produto-material': item.estoque?.produtoFornecedor
        ? item.estoque?.produtoFornecedor?.produto?.descricao
        : 0,
      'produto-categoria': item.estoque?.produtoFornecedor
        ? item.estoque?.produtoFornecedor?.produto?.categoria?.descricao
        : 0,
      'produto-curva-abc': item.estoque?.curvaABC ? item.estoque?.curvaABC : '',
      'produto-curva-abc-empresa': item.estoque?.curvaABCEmpresa
        ? item.estoque?.curvaABCEmpresa
        : '',
      'produto-status': item.estoque?.textoStatus,
      'produto-lote': toLocaleString3(
        item.estoque?.produtoFornecedor?.quantidadePacote
      ),
      'produto-grupo-separacao':
        item.estoque?.produtoFornecedor?.produto?.grupoCarga?.descricao,

      'fornecedor-id': item.estoque?.produtoFornecedor?.fornecedor
        ? item.estoque?.produtoFornecedor?.fornecedor?.id
        : 0,
      'fornecedor-nome': item.estoque?.produtoFornecedor?.fornecedor
        ? item.estoque?.produtoFornecedor?.fornecedor?.descricao
        : 0,

      'recomendacao-quantidade': toLocaleString2(
        item.valorRecomendacao ? item.valorRecomendacao?.quantidade : 0
      ),
      'recomendacao-peso': toLocaleString(
        item.valorRecomendacao ? item.valorRecomendacao?.peso : 0
      ),
      'recomendacao-volume': toLocaleString(
        item.valorRecomendacao ? item.valorRecomendacao?.volume : 0
      ),
      'recomendacao-custo': toLocaleString(
        item.valorRecomendacaoCustoFinal ? item.valorRecomendacaoCustoFinal : 0
      ),
      'recomendacao-tipo-alerta': getStatus(item.motivoRecomendacao),
      'recomendacao-nivel-servico': (item.valorRecomendacao
        ? item.valorRecomendacao?.nivelServico * 100
        : 0
      ).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }),

      'compra-peso': toLocaleString(item.desejada?.peso),
      'compra-volume': toLocaleString(item.desejada?.volume),
      'compra-desejada':
        (item.ajustadoPeloFaturamentoMinimo === true ? 'T' : 'F') +
        (item.desejada
          ? parseCurrency({
              value: item.desejada.quantidade,
              country: 'pt-br',
              minFraction: 0,
              maxFraction: 0
            })
          : 0),
      'compra-custo': toLocaleString(item.desejadaCustoFinal),
      'compra-custo-unit': toLocaleString(
        item.estoque.custoUnitarioFatorConversao
      ),
      'compra-nivel-servico': (
        item.desejada?.nivelServico * 100
      ).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }),
      'estoque-max': toLocaleString2(item.estoque?.maximo),
      'estoque-cd': toLocaleString2(
        item.estoque?.disponivelReservadoCentroDistribuicao
      ),
      'estoque-reservado': toLocaleString2(item.estoque?.quantidadeReservada),
      'estoque-id': item.estoque?.id,
      'estoque-disponivel': parseCurrency({
        value: item.estoque?.disponivel,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-transito': toLocaleString2(item.estoque?.ordenadoCompra),
      'estoque-transito-transferencia': toLocaleString2(
        item.estoque?.ordenadoTransferencia
      ),
      'estoque-dep': toLocaleString2(
        item.estoque.estoquesIndisponiveis?.Deposito16
          ? item.estoque.estoquesIndisponiveis?.Deposito16
          : 0
      ),
      'estoque-outros': toLocaleString2(
        item.estoque.estoquesIndisponiveis?.Luizinho
          ? item.estoque.estoquesIndisponiveis?.Luizinho
          : 0
      ),
      'estoque-venda-diaria': parseCurrency({
        value: item.previsaoDemanda
          ? item.previsaoDemanda?.vendasMediasDiarias
          : 0,
        country: 'pt-br',
        minFraction: 2,
        maxFraction: 2
      }),
      'estoque-venda-mensal': toLocaleString(
        item.previsaoDemanda
          ? removeCasasDecimais(item.previsaoDemanda?.vendasMediasDiarias * 30)
          : 0
      ),
      'estoque-venda-projetada': toLocaleString(
        removeCasasDecimais(item.previsaoDemanda.estimativaVenda)
      ),
      'estoque-qtde-ponto-pedido': toLocaleString(
        item.estoque.pontoPedido ? item.estoque.pontoPedido : 0
      ),

      'cobertura-alvo': parseCurrency({
        value: item.coberturaAlvo,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'cobertura-atual': parseCurrency({
        value: item.previsaoDemanda
          ? item.previsaoDemanda?.coberturaDisponivel
          : 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'cobertura-transito': toLocaleString2(item.transito),
      'cobertura-dep-16': parseCurrency({
        value: item.previsaoDemanda
          ? item.previsaoDemanda.coberturaDisponivelDep16
          : 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'cobertura-ponto-pedido': item.estoque.pontoPedidoDias
        ? item.estoque.pontoPedidoDias
        : 0,
      'cobertura-sugestao': toCoverLocaleString(
        item.valorRecomendacao ? item.valorRecomendacao?.cobertura : 0
      ),
      'cobertura-desejada': item.coberturaDesejada ? item.coberturaDesejada : 0,
      'cobertura-diferenca': toLocaleString2(
        item.diferenca ? item.diferenca : 0
      ),
      'gerente-produto-id': item.estoque.gerenteProdutoId,
      'gerente-produto-desc': item.estoque.gerenteProdutoDescricao,
      'produto-sub-categoria':
        item.estoque?.subCategoriaDescricao?.toUpperCase(),
      'vmm-primeira-entrada': item.previsaoDemanda?.primeiraEntradaDoProduto
        ? new Date(
            item.previsaoDemanda.primeiraEntradaDoProduto.split('T')[0] +
              'T12:00:00'
          ).toLocaleDateString('pt-BR')
        : '—',
      'vmm-janela-efetiva': item.previsaoDemanda?.janelaEfetivaDeDias
        ? `${item.previsaoDemanda.janelaEfetivaDeDias} dias`
        : '—',
      'ruptura-zero-dias':
        item.rupturaZeroDias != null
          ? item.rupturaZeroDias
            ? 'Sim'
            : 'Não'
          : '-',
      'ruptura-dez-dias':
        item.rupturaDezDias != null
          ? item.rupturaDezDias
            ? 'Sim'
            : 'Não'
          : '-',
      'calculo-saida-diaria':
        item.previsaoDemanda?.etapasCalculoSaidaMediaDiaria || [],
      'calculo-quantidade': item.etapasCalculoQuantidadeRecomendada || []
    })
  }

  return res
}
